class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(
      (entries, observer) => this.handleIntersection(entries, observer),
      { rootMargin: '0px 0px 600px 0px' }
    ).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) {
      return;
    }
    observer.unobserve(this);
    fetch(this.dataset.url)
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((error) => {
      });
  }
}
customElements.define('product-recommendations', ProductRecommendations);